<template>
  <multiselect
    v-model="selected"
    :options="options"
    placeholder=""
    selectLabel=""
    selectedLabel="«"
    :multiple="isMulti === true"
    deselectLabel=""
    :allowEmpty="allowEmpty === true"
    :preselectFirst="true"
    :loading="isLoading"
    @input="onChange"
    label="nome"
    track-by="id"
    :disabled="isDisabled"
  >
    <template slot="tag" slot-scope="{ option, remove }" class="d-flex">
      <span class="multiselect__tag bg-primary text-white">
        <span>{{ option.nome }}</span>
        <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="remove(option)"></i>
      </span>
    </template>
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: [
    'alreadySelected',
    'isRequired',
    'emptyLabel',
    'grupoSelected',
    'isDisabled',
    'isMulti',
    'allowEmpty',
    'nameField'
  ],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      if (e == null) {
        this.$emit('selectChange', 'tipo_metodo_pagamento', null);
        return;
      }
      this.$emit('selectChange', 'tipo_metodo_pagamento', e);
    },
    setOptions(grupo) {
      let filter = 'ativo=true';
      if (grupo) filter += ` and id_grupo=${grupo.id}`;
      this.isLoading = true;
      this.selected = '';
      this.$atenaList
        .getCommon('tipo_metodo_pagamento', { columns: 'id, nome', filter: filter, order: 'id' })
        .then((res) => {
          if (!this.isMulti) this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          this.options = this.options.concat(res.data);
          if (this.alreadySelected) this.selected = this.alreadySelected;
          else if (!this.isMulti) this.selected = { id: null, nome: this.$i18n.t(this.emptyLabel) };

          if (this.nameField.length && this.isMulti) {
            this.$nextTick(() => {
              this.selected = this.$util.getObjectRaw(
                this.options.filter((o) => {
                  return this.nameField.includes(o.id);
                })
              );
            });
          }

          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    }
  },

  watch: {
    grupoSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions(newVal);
      }
    }
  },

  created() {
    this.setOptions(this.grupoSelected);
  }
};
</script>

<style lang="scss" scoped></style>
